import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { When } from 'react-if'
import Avatar from 'Theme/Avatar'

import { PROFILE_IMAGE_TYPE } from '../../Queries/utils'
import { userImageSelector } from '../../utils/user-images-utils'

const UserNameAndAvatar = ({ user, size = 'small', onlyName = false, containerStyles, onClick }) => (
  <Box
    display="flex"
    alignItems="center"
    gap={size === 'medium' || size === 'large' ? 2 : 1}
    sx={{ cursor: onClick ? 'pointer' : 'default' }}
    width="100%"
    style={containerStyles}
    onClick={() => onClick && onClick()}
  >
    <Avatar
      size={size}
      src={userImageSelector(
        user?.user_images,
        PROFILE_IMAGE_TYPE.AVATAR,
        size === 'micro' || size === 'normal' ? 'small' : size,
      )}
    />
    <Box sx={{ display: 'grid', marginLeft: '10px' }}>
      <When condition={!onlyName}>
        <Typography
          variant="h6"
          color="primary.contrastText"
          sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
        >
          {user?.login ? user?.login : ''}
        </Typography>
      </When>
      <Typography
        variant={onlyName ? 'h6' : 'caption'}
        color={onlyName ? 'primary.contrastText' : 'text.tertiary'}
        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
      >
        {`${user?.firstName || ''} ${user?.secondName || ''}`}
      </Typography>
    </Box>
  </Box>
)

UserNameAndAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.oneOf(['micro', 'small', 'normal', 'medium', 'large']),
  onlyName: PropTypes.bool,
  containerStyles: PropTypes.object,
  onClick: PropTypes.func,
}

export default UserNameAndAvatar
